var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"homepage-grid"}},[_c('div',{staticClass:"container"},[_c('module-blog-post-grids',{attrs:{"column":3}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }